import { Fork, Invoke } from '@swf/components/StarsWizard/Flow';
import useWizardExit from '@swf/core/hooks/useWizardExit';
import type { FlowConfig } from '@swf/core/types/Wizard';
import { Action } from '@swf/core/types/Wizard';

import RMFAddress from '../components/RMFAddress/RMFAddress';
import RMFDepositLimit from '../components/RMFDepositLimit/RMFDepositLimit';
import RMFLegalName from '../components/RMFLegalName/RMFLegalName';
import RMFStandaloneFinalPage from '../components/RMFStandaloneFinalPage/RMFStandaloneFinalPage';

import useRMFBaseSteps from './useRMFBaseSteps';
import { Guard } from './useRmfGuards';
import { Service } from './useRmfServices';

const useRmfDefaultFlow = (): FlowConfig => {
  const exitWizard = useWizardExit();

  const jumpToFeatureStep = {
    name: 'jumpToFeatureStep',
    entry: Action.GoJump
  };

  const { forkSignupDepositCheckDone, forkDobCheck, invokeLegalNameSave, invokeSignupDob } =
    useRMFBaseSteps();

  const forkJumpToFeature = new Fork(
    Guard.DoesJumpToFeatureStep,
    [new Invoke(Service.SetJumpCreator, jumpToFeatureStep)],
    [forkSignupDepositCheckDone]
  );

  const forkRmfExit = new Fork(
    Guard.StandaloneRmf,
    [
      RMFStandaloneFinalPage,
      {
        name: 'exitRMF',
        entry: exitWizard,
        type: 'final'
      }
    ],
    [forkJumpToFeature]
  );

  const invokeDepositLimitSave = new Invoke(Service.RmfDepositLimitSave, forkRmfExit);
  const forkDepositLimits = new Fork(Guard.LimitsSelected, forkRmfExit, [invokeDepositLimitSave]);

  const invokeAddressSaveAndRealMoneyEnable = new Invoke(
    Service.RmfRealMoneyFlagAndAddressUpdate,
    RMFDepositLimit,
    RMFAddress
  );

  return [
    invokeSignupDob,
    forkDobCheck,
    invokeLegalNameSave,
    RMFAddress,
    invokeAddressSaveAndRealMoneyEnable,
    RMFDepositLimit,
    forkDepositLimits,
    jumpToFeatureStep
  ];
};

export default useRmfDefaultFlow;
